<template>
    <svg
        width="48"
        height="48"
        viewBox="0 0 48 48"
        fill="none"
        :style="{ backgroundColor }"
        xmlns="http://www.w3.org/2000/svg">
        <path
            d="M37.84 10.02C37.44 8.84 36.32 8 35 8H13C11.68 8 10.58 8.84 10.16 10.02L6 22V38C6 39.1 6.9 40 8 40H10C11.1 40 12 39.1 12 38V36H36V38C36 39.1 36.9 40 38 40H40C41.1 40 42 39.1 42 38V22L37.84 10.02ZM13.7 12H34.28L36.44 18.22H11.54L13.7 12ZM38 32H10V22H38V32Z"
            fill="currentColor" />
        <path
            d="M15 30C16.6569 30 18 28.6569 18 27C18 25.3431 16.6569 24 15 24C13.3431 24 12 25.3431 12 27C12 28.6569 13.3431 30 15 30Z"
            fill="currentColor" />
        <path
            d="M33 30C34.6569 30 36 28.6569 36 27C36 25.3431 34.6569 24 33 24C31.3431 24 30 25.3431 30 27C30 28.6569 31.3431 30 33 30Z"
            fill="currentColor" />
    </svg>
</template>

<script lang="ts">
    import { defineComponent } from 'vue';

    export default defineComponent({
        props: {
            backgroundColor: {
                type: String,
                required: true,
            },
        },
    });
</script>
